import axios from 'axios'
import appconst from './appconst'
import Vue from 'vue'
const ajax = axios.create({
    baseURL: appconst.remoteServiceBaseUrl,
    timeout: 120000,
	headers: {
	    'cache-control': 'no-cache',
	    'Pragma': 'no-cache'
	}
});
ajax.interceptors.request.use(function (config) {	
	if(config.baseURL.indexOf('localhost')==-1){
		if(config.data!=undefined && config.data.istest!=undefined && config.data.istest){			
			config.baseURL="https://gistest.yfpo.com:9106/"
		}
	}
	
	 
    if(!!window.abp.auth.getToken()){
        config.headers.common["Authorization"]="Bearer "+window.abp.auth.getToken();
    }
    config.headers.common[".AspNetCore.Culture"]=window.abp.utils.getCookieValue("Abp.Localization.CultureName");
    config.headers.common["Abp.TenantId"]=window.abp.multiTenancy.getTenantIdCookie();
	
	
	// debugger;
	// //接口鉴权用于修改密码接口
	// if(!!config.data&&!!config.data.headers&&!!config.data.headers.ApiAuth){
	// 		config.headers.common["Authorization"]=config.data.headers.ApiAuth;
	// }

	
	
    return config;
  }, function (error) {
    
    return Promise.reject(error);
});
let vm=new Vue({});
ajax.interceptors.response.use((respon)=>{    
    return respon
},(error)=>{
    if(!!error.response&&!!error.response.data.error&&!!error.response.data.error.message&&error.response.data.error.details){
        vm.$Modal.error({title:error.response.data.error.message,content:error.response.data.error.details})
    }else if(!!error.response&&!!error.response.data.error&&!!error.response.data.error.message){
		if(error.response.data.error.message== "invalid token"){
			 return error.response;
		}
        vm.$Modal.error({title:window.abp.localization.localize("Prompt"),content:error.response.data.error.message})
    }else if(!error.response){
        vm.$Modal.error(window.abp.localization.localize('UnknownError'));
    }
    setTimeout(()=>{
       vm.$Message.destroy();
    },1000);
    return Promise.reject(error);
})
export default ajax;